import script from "./exercisesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./exercisesComponent.vue?vue&type=script&setup=true&lang=js"

import "./exercisesComponent.vue?vue&type=style&index=0&id=e704e068&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e704e068"]])

export default __exports__